import React, { useState } from "react";
import { Alert, Button, Card, Col, Form, Row } from "react-bootstrap";
import { CCAssessmentType } from "../../Physician/Models/CCEnrollment";
import AbpnSpinner from "../../Shared/Components/AbpnSpinner";
import ArticlePathwayTerms from './ArticlePathwayTerms';
import ExamPathwayTerms from './ExamPathwayTerms';
import CcAssessmentPathwayEnrollment, { CcAssessmentPathwayEnrollmentCertificate } from "../Models/CcAssessmentPathwayEnrollment";
import { deepCopy } from "../../Shared/Utility/DeepCopy";

interface IProps {
    isSectionOpen: boolean;
    onSave?: () => void;
    onUpdate?: () => void;
    onOpen?: () => void;
    disabled?: boolean;
    isLoading?: boolean;
    onCompleteEnrollment: () => void;
    onPrevious: () => void;
    pathwayEnrollment: CcAssessmentPathwayEnrollment;
    updateCertificates: (certificates: Array<CcAssessmentPathwayEnrollmentCertificate>) => void;
}

export default function TermsAndAttestation(props: IProps){
    const [errorMessages, setErrorMessages] = useState([]);
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

    const getEnrolledCertificates = () => {
        return props.pathwayEnrollment.ccEnrollmentCertificates.filter(_ => _.isEnrolled);
    }

    const getAbccCertifications = () => {
        return props.pathwayEnrollment.ccEnrollmentCertificates.filter(_ => _.isEnrolled && _.isAbccEligible && _.ccAssessmentType == CCAssessmentType.Article);
    }

    const getExamCertifications = () => {
        return props.pathwayEnrollment.ccEnrollmentCertificates.filter(_ => _.isEnrolled &&  (_.ccAssessmentType == CCAssessmentType.Exam || _.ccAssessmentType == CCAssessmentType.Other));
    }

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setIsSubmitDisabled(true);

        // todo validate all attested
        if (validateSelection()){
            props.onCompleteEnrollment();
        }

        setIsSubmitDisabled(false);
        
    }

    const validateSelection = () => {
        let newErrorMessages = [];
        var unattestedCerts = props.pathwayEnrollment.ccEnrollmentCertificates.filter(_ => _.isEnrolled && _.ccAssessmentAttestationDate === null);
        if (unattestedCerts.length > 0)
        {
            newErrorMessages.push("You must agree to the terms for all pathways selected.");
        }
        
        setErrorMessages(newErrorMessages);
        return newErrorMessages.length === 0;
    }

    const onUpdateCertificateAttestation = (certificate: CcAssessmentPathwayEnrollmentCertificate) => {
        var updated = deepCopy(props.pathwayEnrollment.ccEnrollmentCertificates);
        var index = updated.findIndex((_: CcAssessmentPathwayEnrollmentCertificate) => _.certificateId == certificate.certificateId);
        updated[index] = certificate;
        props.updateCertificates(updated);
    }

    const onPrevious = async (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        props.onPrevious();
    }


    if (props.isLoading || isSubmitDisabled) return <AbpnSpinner></AbpnSpinner>
    return (
        <React.Fragment>
        { !(props.disabled) && !(isSubmitDisabled) &&
                <Card className="mb-3" border="pp-secondary-grey">
                    {getEnrolledCertificates().length > 0 && <Card.Body>
                        <Card.Title className="font-weight-bolder">
                        POLICY STATEMENT
                        </Card.Title>
                        <Row className="mt-3">
                                    <Col xs={12} md={12} lg={12} xl={12}>
                                        <Form noValidate onSubmit={(e) => onSubmit(e)}>
                                            <h3>Please review an accept the terms below:</h3>
                                                    {getAbccCertifications().length > 0 &&
                                                        <ArticlePathwayTerms 
                                                            abccCertificates={getAbccCertifications()}
                                                            updateCertificateAttestation={onUpdateCertificateAttestation} />
                                                    }
                                                    {getExamCertifications().length > 0 &&
                                                        <ExamPathwayTerms 
                                                        examCertificates={getExamCertifications()}
                                                        updateCertificateAttestation={onUpdateCertificateAttestation}/>
                                                    }

                                                {errorMessages.length > 0 &&
                                                    <Alert className="pp-font-size-smaller" variant="pp-alert-danger">
                                                        {errorMessages.map(errorMessage => <p>{errorMessage}</p>)}
                                                    </Alert>
                                                    }
                                                    {props.isLoading ? <AbpnSpinner /> : 
                                                        <Row>
                                                        <Col xs={12} lg={6}>
                                                            <Button type="button" variant="outline-pp-primary" onClick={onPrevious}>Previous</Button>
                                                        </Col>
                                                        <Col xs={12} lg={6}>
                                                            <Button disabled={isSubmitDisabled} type="submit" variant="pp-primary">Complete Enrollment</Button>
                                                        </Col>
                                                    </Row>
                                                }
                                        </Form>
                                    </Col>
                                </Row>
                    </Card.Body>}
                    {getEnrolledCertificates().length == 0 && <Card.Body>
                        <Card.Title className="font-weight-bolder">
                        UNENROLL FROM CC
                        </Card.Title>
                        <Row className="mt-3">
                                    <Col xs={12} md={12} lg={12} xl={12}>
                                        <Form noValidate onSubmit={(e) => onSubmit(e)}>
                                            <p>You have chosen to unenroll all certificates from CC.</p> 

                                            {props.isLoading ? <AbpnSpinner /> : 
                                                    <Row>
                                                    <Col xs={12} lg={6}>
                                                        <Button type="button" variant="outline-pp-primary" onClick={onPrevious}>Previous</Button>
                                                    </Col>
                                                    <Col xs={12} lg={6}>
                                                        <Button disabled={isSubmitDisabled} type="submit" variant="pp-primary">Complete Unenrollment</Button>
                                                    </Col>
                                                </Row>
                                            }
                                        </Form>
                                    </Col>
                                </Row>
                    </Card.Body>}
                </Card>        
        }
    </React.Fragment>
    )
}